import React, { useState, useEffect } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

const months = [
  'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
];

const HolidayForm = () => {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);

  // Neue Feiertagsfelder
  const [newMonth, setNewMonth] = useState('');
  const [newDay, setNewDay] = useState('');
  const [newName, setNewName] = useState('');
  const [newRegion, setNewRegion] = useState('');
  const [newYear, setNewYear] = useState('');
  const [newIsRecurring, setNewIsRecurring] = useState(false);

  // Bearbeitungs-States
  const [editingId, setEditingId] = useState(null);
  const [editedMonth, setEditedMonth] = useState('');
  const [editedDay, setEditedDay] = useState('');
  const [editedName, setEditedName] = useState('');
  const [editedRegion, setEditedRegion] = useState('');
  const [editedYear, setEditedYear] = useState('');
  const [editedIsRecurring, setEditedIsRecurring] = useState(false);

  // Lade Feiertage
  const fetchHolidays = async () => {
    try {
      const response = await api.get('/holidays');
      const sorted = response.data.sort((a, b) => a.month - b.month || a.day - b.day);
      setHolidays(sorted);
    } catch (error) {
      console.error('Fehler beim Laden der Feiertage:', error);
      alert('Fehler beim Laden der Feiertage');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHolidays();
  }, []);

  // Hinzufügen
  const handleAddHoliday = async () => {
    if (newMonth === '' || newDay === '') {
      alert('Bitte Monat und Tag eingeben!');
      return;
    }
    try {
      await api.post('/holidays', {
        month: parseInt(newMonth, 10),
        day: parseInt(newDay, 10),
        name: newName || null,
        region: newRegion || null,
        year:  newIsRecurring ? null : parseInt(newYear, 10),
        isRecurring: newIsRecurring,
      });
      setNewMonth(''); setNewDay(''); setNewName(''); setNewRegion(''); setNewYear(''); setNewIsRecurring(false);
      fetchHolidays();
    } catch (error) {
      console.error('Fehler beim Hinzufügen des Feiertags:', error);
      alert('Fehler beim Hinzufügen des Feiertags');
    }
  };

  // Löschen
  const handleDeleteHoliday = async (id) => {
    try {
      await api.delete(`/holidays/${id}`);
      setHolidays(holidays.filter(h => h.id !== id));
    } catch (error) {
      console.error('Fehler beim Löschen des Feiertags:', error);
      alert('Fehler beim Löschen des Feiertags');
    }
  };

  // Bearbeiten starten
  const handleEditHoliday = (h) => {
    setEditingId(h.id);
    setEditedMonth(h.month.toString());
    setEditedDay(h.day.toString());
    setEditedName(h.name || '');
    setEditedRegion(h.region || '');
    setEditedYear(h.year != null ? h.year.toString() : '');
    setEditedIsRecurring(!!h.isRecurring);
  };

  // Abbrechen
  const handleCancelEdit = () => {
    setEditingId(null);
    setEditedMonth(''); setEditedDay(''); setEditedName(''); setEditedRegion(''); setEditedYear(''); setEditedIsRecurring(false);
  };

  // Aktualisieren
  const handleUpdateHoliday = async (id) => {
    try {
      await api.put(`/holidays/${id}`, {
        month: parseInt(editedMonth, 10),
        day: parseInt(editedDay, 10),
        name: editedName || null,
        region: editedRegion || null,
         year: editedIsRecurring ? null : parseInt(editedYear, 10),
        isRecurring: editedIsRecurring,
      });
      setEditingId(null);
      fetchHolidays();
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Feiertags:', error);
      alert('Fehler beim Aktualisieren des Feiertags');
    }
  };

  if (loading) return <div>Daten werden geladen...</div>;

  return (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
    <div style={{ width: '800px' }}>
      <Helmet>
        <title>Feiertage verwalten</title>
        <meta name="description" content="Feiertage verwalten" />
      </Helmet>

      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>
        Feiertage verwalten
      </h2>

      {/* Hinzufügen */}
      <div
        style={{
          display: 'grid',
          /* Monat, Tag, Name, Region, Jahr, Wiederkehrend, Button */
          gridTemplateColumns: '120px 80px 2fr 2fr 80px auto auto',
          gap: '10px',
          marginBottom: '20px',
          alignItems: 'center',
        }}
      >
        <select
          value={newMonth}
          onChange={e => setNewMonth(e.target.value)}
          style={{
            padding: '5px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            marginLeft: '4px',
            marginTop: '0px',
          }}
        >
          <option value="">Monat</option>
          {months.map((m, idx) => (
            <option key={idx} value={idx}>
              {m}
            </option>
          ))}
        </select>

        <input
          type="number"
          min="1"
          max="31"
          placeholder="Tag"
          value={newDay}
          onChange={e => setNewDay(e.target.value)}
          style={{
            padding: '5px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            width: '80px',
          }}
        />

        <input
          type="text"
          placeholder="Name"
          value={newName}
          onChange={e => setNewName(e.target.value)}
          style={{
            padding: '5px',
            borderRadius: '4px',
            border: '1px solid #ccc',
          }}
        />

        <input
          type="text"
          placeholder="Region"
          value={newRegion}
          onChange={e => setNewRegion(e.target.value)}
          style={{
            padding: '5px',
            borderRadius: '4px',
            border: '1px solid #ccc',
          }}
        />

        <input
          type="number"
          placeholder="Jahr"
          min="1900"
          max="2100"
          value={newYear}
          onChange={e => setNewYear(e.target.value)}
          disabled={newIsRecurring}
          style={{
            padding: '5px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            width: '80px',
          }}
        />

        <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <input
            type="checkbox"
            checked={newIsRecurring}
            onChange={e => setNewIsRecurring(e.target.checked)}
          />
          Wiederkehrend
        </label>

        <button
          onClick={handleAddHoliday}
          style={{
            padding: '6px 12px',
            background: '#28a745',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Hinzufügen
        </button>
      </div>

      {/* Liste */}
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {holidays.map(h => (
          <li
            key={h.id}
            style={{
              display: 'grid',
              /* Monat, Tag, Name, Region, Jahr, Recurring, Aktionen */
              gridTemplateColumns: '120px 80px 2fr 2fr 80px auto auto',
              gap: '10px',
              alignItems: 'center',
              marginBottom: '10px',
            }}
          >
            {editingId === h.id ? (
              <>
                <select
                  value={editedMonth}
                  onChange={e => setEditedMonth(e.target.value)}
                  style={{
                    padding: '5px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    marginLeft: '4px',
                  }}
                >
                  <option value="">Monat</option>
                  {months.map((m, idx) => (
                    <option key={idx} value={idx}>
                      {m}
                    </option>
                  ))}
                </select>

                <input
                  type="number"
                  value={editedDay}
                  min="1"
                  max="31"
                  onChange={e => setEditedDay(e.target.value)}
                  style={{
                    padding: '5px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    width: '80px',
                  }}
                />

                <input
                  type="text"
                  value={editedName}
                  onChange={e => setEditedName(e.target.value)}
                  style={{
                    padding: '5px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                  }}
                />

                <input
                  type="text"
                  value={editedRegion}
                  onChange={e => setEditedRegion(e.target.value)}
                  style={{
                    padding: '5px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                  }}
                />

                <input
                  type="number"
                  value={editedYear}
                  min="1900"
                  max="2100"
                  onChange={e => setEditedYear(e.target.value)}
                  disabled={editedIsRecurring}
                  style={{
                    padding: '5px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    width: '80px',
                  }}
                />

                <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <input
                    type="checkbox"
                    checked={editedIsRecurring}
                    onChange={e => setEditedIsRecurring(e.target.checked)}
                  />
                  Ja
                </label>

                <div>
                  <button
                    onClick={() => handleUpdateHoliday(h.id)}
                    style={{ marginRight: '5px' }}
                  >
                    ✅
                  </button>
                  <button onClick={handleCancelEdit}>✖️</button>
                </div>
              </>
            ) : (
              <>
                <span>{months[h.month]}</span>
                <span>{h.day}</span>
                <span>{h.name}</span>
                <span>{h.region}</span>
                <span>{h.year != null ? h.year : '-'}</span>
                <input type="checkbox" checked={h.isRecurring} disabled />
                <div>
                  <button
                    onClick={() => handleEditHoliday(h)}
                    style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: '#007bff', // Rot für Löschen
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
                  >
                    Bearbeiten
                  </button>
                  <button 
                  onClick={() => handleDeleteHoliday(h.id)}
                  style={{
                        fontSize: '15px',
                        padding: '5px 10px',
                        background: '#dc3545', // Rot für Löschen
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                      }}
                  >
                    Löschen
                    </button>
                </div>
              </>
            )}
          </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HolidayForm;
